module.exports = __webpack_public_path__ + "static/media/9-rectangle-dirty.a70f50b9.svg";